export default __webpack_public_path__ + "a06a5fb9059d9165ae791f07296add21.svg";